import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { BiEventType, BiDataHook, ReferralType, } from '@wix/da-bi/pkg/constants';
import Button from '../../../../Button';
import useLeaveACommentNotification from '../useLeaveACommentNotification';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import MobileFreeAndPcpPopover from '../MobileFreeAndPcpPopover';
var MobileDownloadLink = function (_a) {
    var _b;
    var deviation = _a.deviation, _c = _a.deviation, deviationId = _c.deviationId, _d = _c.extended, _e = _d === void 0 ? {} : _d, download = _e.download, pcp = _e.pcp;
    var t = useTranslation().t;
    var _f = useRestrictToLoggedIn(), isLoggedIn = _f.isLoggedIn, restrictToLoggedIn = _f.restrictToLoggedIn;
    var _g = useSubscriptionTier(deviation), needsSubscription = _g.needsSubscription, subscriptionsTabUrl = _g.subscriptionsTabUrl, isOwner = _g.isOwner, isSubscribedButBlocked = _g.isSubscribedButBlocked;
    var _h = useState(false), isPopoverOpen = _h[0], setIsPopoverOpen = _h[1];
    var addLeaveACommentNotification = useLeaveACommentNotification(deviation);
    var downloadUrl = download === null || download === void 0 ? void 0 : download.url;
    // if no free or premium download, render nothing
    if (!downloadUrl && !pcp) {
        return null;
    }
    // if premium only or both free and premium, we open a modal
    if (pcp) {
        return isOwner ? (React.createElement(Button, { view: "b18", href: (_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.editUrl }, t('actionbar.pcp.owned'))) : (React.createElement(React.Fragment, null,
            React.createElement(Button, { view: "b18", onClick: function () { return setIsPopoverOpen(true); } }, t(download
                ? 'actionbar.mobilePcp.freeAndPremiumDownload'
                : 'actionbar.mobilePcp.premiumDownload')),
            isPopoverOpen && (React.createElement(MobileFreeAndPcpPopover, { deviation: deviation, requestClose: function () { return setIsPopoverOpen(false); } }))));
    }
    var checkoutOrDownloadUrl = needsSubscription
        ? subscriptionsTabUrl
        : downloadUrl;
    // if free only, we download directly from this button
    return (React.createElement(Button, { "data-hook": BiDataHook.DEVIATION_DOWNLOAD_BUTTON, view: "b18", href: isLoggedIn ? checkoutOrDownloadUrl : undefined, download: isLoggedIn, onClick: restrictToLoggedIn(ReferralType.ANON_DOWNLOAD, addLeaveACommentNotification), disabled: isSubscribedButBlocked, biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviationId,
            ispaiddownload: 0,
        } }, t(needsSubscription
        ? 'actionbar.download.mustSubscribe'
        : 'common.download')));
};
MobileDownloadLink.displayName = 'MobileDownloadLink';
export default MobileDownloadLink;
//# sourceMappingURL=MobileDownloadLink.js.map